export default "__VITE_ASSET__CcGSPYEr__"